import { type Attachment } from '@fcom/ui-components/components/interfaces';

export enum ClaimMissingPartnerPointsFormField {
  MEMBER_NAME = '01___Member_Name',
  MEMBER_NUMBER = '02___Member_Number',
  EMAIL = '03___Email',
  ATTACHMENT = 'attachment',
  ADDITIONAL_INFORMATION = '05___Additional_Information',
}

export type ClaimMissingPartnerPointsFormData = {
  claimMissingPartnerPoints: {
    [ClaimMissingPartnerPointsFormField.MEMBER_NAME]: string;
    [ClaimMissingPartnerPointsFormField.MEMBER_NUMBER]: string;
    [ClaimMissingPartnerPointsFormField.EMAIL]: string;
    [ClaimMissingPartnerPointsFormField.ATTACHMENT]: Attachment | Attachment[];
    [ClaimMissingPartnerPointsFormField.ADDITIONAL_INFORMATION]: string;
  };
};
